// extracted by mini-css-extract-plugin
export var tosLink = "_8h-0";